import React, { useEffect } from "react";
import Loading from "components/Loading/Loading";
import RedemptionContainer from "./RedemptionContainer";
import { useHistory, useParams } from "react-router-dom";
import { useUser } from "context/Auth";
import { useDispatch } from "react-redux";
import postApi from "store/helpers/postApi";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";
import getResponseErrorMessage from "utils/getResponseErrorMessage";

export default function RedeemCoupon() {
  const { code } = useParams();
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();

  const showNotif = (text) => {
    enqueueSnackbar(text, {
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      action: (key) => (
        <Button color="primary" size="small" onClick={() => closeSnackbar(key)}>
          Ok
        </Button>
      ),
    });
  };

  const user = useUser();

  const submitRedeemCode = () => {
    dispatch(
      postApi(`${user.id}/coupon/redeem`, {
        code: code,
      })
    )
      .then(() => {
        showNotif("Awesome! We've succesfully applied your coupon!");
        history.replace(`/plan/activate`);
      })
      .catch((e) => showNotif(getResponseErrorMessage(e)));
  };

  useEffect(() => {
    submitRedeemCode();
  }, []);

  return (
    <RedemptionContainer loginActive={true}>
      <Loading text="Redeeming your AppSumo Code..." />
    </RedemptionContainer>
  );
}
